var map = {
	"./fajnsmekr.png": 7176,
	"./vlasyStrih.png": 2680,
	"./vlasyStrihVousyHotTowel.png": 2934,
	"./vlasyStrihaVousyUprava.png": 830,
	"./vousyUprava.png": 222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1120;